/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RttrQrRedeemRequest
 */
export interface RttrQrRedeemRequest {
    /**
     * The token embedded in the QR code URL
     * @type {string}
     * @memberof RttrQrRedeemRequest
     */
    token: string;
}

/**
 * Check if a given object implements the RttrQrRedeemRequest interface.
 */
export function instanceOfRttrQrRedeemRequest(value: object): value is RttrQrRedeemRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function RttrQrRedeemRequestFromJSON(json: any): RttrQrRedeemRequest {
    return RttrQrRedeemRequestFromJSONTyped(json, false);
}

export function RttrQrRedeemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrQrRedeemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function RttrQrRedeemRequestToJSON(json: any): RttrQrRedeemRequest {
    return RttrQrRedeemRequestToJSONTyped(json, false);
}

export function RttrQrRedeemRequestToJSONTyped(value?: RttrQrRedeemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

